import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-104838b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "prize-list"
};
const _hoisted_2 = {
  key: 0,
  class: "prize-warning"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 抱歉，你未中奖 ");
const _hoisted_5 = {
  key: 0,
  class: "prize-warning"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 开奖后7天内未填写地址，已视为自动放弃中 ");
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "user-name"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "prize-info"
};
const _hoisted_12 = {
  class: "info-item"
};
const _hoisted_13 = {
  class: "label"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 奖品");
const _hoisted_16 = {
  class: "value"
};
const _hoisted_17 = {
  class: "info-item"
};
const _hoisted_18 = {
  class: "label"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 发货时间");
const _hoisted_21 = {
  class: "value"
};
const _hoisted_22 = {
  key: 1,
  class: "virtual-info"
};
const _hoisted_23 = {
  key: 0,
  class: "virtual-title"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 奖品内容 ");
const _hoisted_26 = {
  key: 1,
  class: "virtual-title"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 发货方式 ");
const _hoisted_29 = {
  class: "virtual-des"
};
const _hoisted_30 = {
  key: 0,
  class: "physical-info"
};
const _hoisted_31 = {
  key: 0,
  class: "logistics-info"
};
const _hoisted_32 = {
  class: "logistics-title"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  class: "logistics-des"
};
const _hoisted_35 = {
  class: "address-info"
};
const _hoisted_36 = {
  class: "address-title"
};
const _hoisted_37 = ["src"];
const _hoisted_38 = {
  class: "address-detail"
};
const _hoisted_39 = {
  class: "address-add-des"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 请在开奖后7天内填写地址，超期视为自动放弃中奖资格。 ");
const _hoisted_42 = {
  key: 1,
  style: {
    "height": "15px"
  }
};
const _hoisted_43 = {
  class: "prize-list-section"
};
const _hoisted_44 = {
  class: "prize-list-section-title"
};
const _hoisted_45 = {
  class: "prize-list-section-title-count"
};
const _hoisted_46 = {
  class: "winners-grid"
};
const _hoisted_47 = ["onClick"];
const _hoisted_48 = ["src"];
const _hoisted_49 = {
  class: "winner-name"
};
import { reactive, onMounted, onBeforeMount, computed } from 'vue';
import { useRoute } from 'vue-router';
import { getRedNotePrizeInfo, uploadRednoteAddressInfo } from '@/api';
import { mdToast, QuickCopy } from '../../../utils/tools';
import domain from "@/service/domain";
import router from '@/router';
import store from '@/store';
import redirect from '@/service/redirect';
export default {
  setup(__props) {
    const route = useRoute();
    const state = reactive({
      loading: true,
      rednote_draw_id: '',
      respon: {},
      draw_info: {},
      win_info: {},
      address_info: {},
      win_list: []
    });
    const ifLogin = computed(() => store.state.user.ifLogin);

    //created()方法内调用请求
    onBeforeMount(() => {
      state.rednote_draw_id = route.params.id || route.query.id; // 同时支持 params 和 query 方式获取 id
      if (state.rednote_draw_id && state.rednote_draw_id.length > 0) {
        sendRedNotePrizeInfoRequest();
      } else {
        mdToast('未找到活动ID');
      }
    });
    onMounted(() => {
      if (sessionStorage.getItem('address')) {
        let address_info = JSON.parse(sessionStorage.getItem('address'));
        uploadAddressInfo(address_info);
        sessionStorage.removeItem('address');
      }
    });
    async function sendRedNotePrizeInfoRequest() {
      if (!ifLogin.value) {
        return redirect.to('login');
      }
      const {
        status,
        data,
        message
      } = await getRedNotePrizeInfo({
        rednote_draw_id: state.rednote_draw_id // 同时支持 params 和 query 方式获取 id
      });
      if (status == 0) {
        if (data) {
          state.draw_info = data.draw_info;
          state.win_info = data.win_info;
          state.address_info = data.address_info;
          state.win_list = data.list;
        }
      } else {
        mdToast(message);
      }
      state.loading = false;
    }

    // 上传地址
    async function uploadAddressInfo(address_info) {
      const {
        status,
        message
      } = await uploadRednoteAddressInfo({
        rednote_draw_id: state.rednote_draw_id,
        mobile: address_info.address_mobile,
        user_name: address_info.address_name,
        province: address_info.province,
        city: address_info.city,
        area: address_info.county,
        street: address_info.street,
        address_detail: address_info.address,
        address_id: address_info.id
      });
      if (status == 0) {
        mdToast('地址上传成功');

        // 重新请求数据
        sendRedNotePrizeInfoRequest();
      } else {
        mdToast(message);
      }
    }

    // 复制虚拟码
    function copyCode(code) {
      QuickCopy(code);
    }

    // 填写地址
    function goAddress() {
      // eslint-disable-next-line
      graft.app({
        functionName: "chooseAddress",
        functionParams: {},
        callBack: e => {
          if (e.errorCode == 0) {
            // 上传地址
            uploadAddressInfo(e.data);
          }
        },
        webFun: () => {
          router.push('/address/address_list');
        }
      });
    }

    // 查看物流
    const checkLogistics = win_info => {
      let url = `/order/logistics/info?express_no=${win_info.express_no}&express_no_mix=${win_info.express_no_mix}&express_name=${win_info.express_company}`;

      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}` + url,
        webFun: () => {
          router.push({
            path: '/order/logistics/info',
            query: {
              express_no: win_info.express_no,
              express_no_mix: win_info.express_no_mix,
              express_name: win_info.express_company
            }
          });
        }
      });
    };

    // 前往用户中心
    function goUserCenter(user_id) {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://ucenter?id=${user_id}`,
        webFun: () => {
          router.push(`/user/homePage/${user_id}`);
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_Error = _resolveComponent("Error");
      return _unref(state).draw_info.prize_title ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(state).win_info.if_prize != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        class: "warn-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_warning_yellow.png', 30)
      }, null, 8, _hoisted_3), _hoisted_4])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(state).draw_info.prize_type == 1 && _unref(state).win_info.if_expired == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
        class: "warn-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_warning_yellow.png', 30)
      }, null, 8, _hoisted_6), _hoisted_7])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "prize-header",
        style: _normalizeStyle({
          backgroundImage: `url(${_ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_header.png', 690)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        })
      }, [_createElementVNode("img", {
        class: "user-avatar",
        src: _ctx.$imgUrlFilter(_unref(state).win_info.icon, 140),
        alt: "头像"
      }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(state).win_info.nickname), 1), _createElementVNode("img", {
        class: "prize_win_icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_win_icon.png', 200)
      }, null, 8, _hoisted_10)], 4), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
        class: "prize_icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_prize_icon.png', 24)
      }, null, 8, _hoisted_14), _hoisted_15]), _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(state).draw_info.prize_title), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
        class: "prize_send_icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_time_icon.png', 28)
      }, null, 8, _hoisted_19), _hoisted_20]), _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(state).draw_info.distribute_time), 1)])]), _unref(state).draw_info.prize_type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_unref(state).win_info.fictitious_code ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("img", {
        class: "virtual-prize-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_%20virtual_icon.png', 28)
      }, null, 8, _hoisted_24), _hoisted_25])) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("img", {
        class: "virtual-send-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_deliver_icon.png', 30)
      }, null, 8, _hoisted_27), _hoisted_28])), _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(state).win_info.fictitious_code ? _unref(state).win_info.fictitious_code : '该奖品为虚拟产品，发起人在线发货'), 1), _unref(state).win_info.fictitious_code ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "virtual-btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => copyCode(_unref(state).win_info.fictitious_code), ["stop"]))
      }, "复制")) : _createCommentVNode("", true)])) : _unref(state).draw_info.prize_type == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_unref(state).win_info.if_expired == 0 || _unref(state).address_info && _unref(state).address_info.user_mobile ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_unref(state).address_info && _unref(state).address_info.user_mobile ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(state).win_info.express_no ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("img", {
        class: "logistics-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_deliver_icon.png', 30),
        alt: "快递"
      }, null, 8, _hoisted_33), _createTextVNode(" " + _toDisplayString(_unref(state).win_info.express_company), 1)]), _createElementVNode("div", _hoisted_34, " 快递单号 " + _toDisplayString(_unref(state).win_info.express_no), 1), _createElementVNode("div", {
        class: "logistics-action-btn",
        onClick: _cache[1] || (_cache[1] = $event => checkLogistics(_unref(state).win_info))
      }, "查看物流")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("img", {
        class: "address-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_location_icon.png', 24)
      }, null, 8, _hoisted_37), _createTextVNode(" " + _toDisplayString(_unref(state).address_info.user_name) + " （" + _toDisplayString(_unref(state).address_info.user_mobile) + "） ", 1)]), _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(state).address_info.province) + " " + _toDisplayString(_unref(state).address_info.city) + " " + _toDisplayString(_unref(state).address_info.area) + " " + _toDisplayString(_unref(state).address_info.street) + " " + _toDisplayString(_unref(state).address_info.address_detail), 1)])], 64)) : _unref(state).win_info.if_expired == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", {
        class: "address-add-btn",
        onClick: goAddress
      }, "填写地址"), _createElementVNode("div", _hoisted_39, [_createElementVNode("img", {
        class: "address-warning-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/prize/result/prize_result_warning_gray.png', 22)
      }, null, 8, _hoisted_40), _hoisted_41])], 64)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_42))], 64)) : _createCommentVNode("", true)], 64)), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createTextVNode("奖品：" + _toDisplayString(_unref(state).draw_info.prize_title) + " ", 1), _createElementVNode("span", _hoisted_45, "共" + _toDisplayString(_unref(state).win_list.length) + "人", 1)]), _createElementVNode("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).win_list, (winner, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "winner-item",
          onClick: $event => goUserCenter(winner.user_id)
        }, [_createElementVNode("img", {
          class: "winner-avatar",
          src: _ctx.$imgUrlFilter(winner.icon, 80),
          alt: "获奖者头像"
        }, null, 8, _hoisted_48), _createElementVNode("div", _hoisted_49, _toDisplayString(winner.nick_name), 1)], 8, _hoisted_47);
      }), 128))])])])) : !_unref(state).loading ? (_openBlock(), _createBlock(_component_Error, {
        key: 1,
        style: {
          minHeight: '500px'
        },
        message: "活动不存在或未开奖",
        class: "empty-box"
      })) : _createCommentVNode("", true);
    };
  }
};